// Per-service rich content: hero images, packs of cards, packages, testimonials, case study.
// Reuses the same images already loaded on Home.jsx (already cached in browser).

export const SERVICE_IMG = {
  move: "https://customer-assets.emergentagent.com/job_mopper-reserve/artifacts/qedruq3t_478f1f53-dc1e-45fd-83c7-0f0f91fede73.png",
  clear: "https://customer-assets.emergentagent.com/job_mopper-reserve/artifacts/vwjwaf6b_ChatGPT%20Image%2011%20juin%202026%2C%2000_10_18.png",
  declutter: "https://customer-assets.emergentagent.com/job_mopper-reserve/artifacts/afko4rp6_ChatGPT%20Image%2010%20juin%202026%2C%2023_49_37.png",
  organize: "https://customer-assets.emergentagent.com/job_mopper-reserve/artifacts/6rxlcq28_ChatGPT%20Image%2011%20juin%202026%2C%2000_32_59.png",
  clean: "https://customer-assets.emergentagent.com/job_mopper-reserve/artifacts/5heg7dg6_image.png",
  recycle: "https://customer-assets.emergentagent.com/job_mopper-reserve/artifacts/8mpd0m48_ChatGPT%20Image%2011%20juin%202026%2C%2000_38_25.png",
  assembly: "https://customer-assets.emergentagent.com/job_mopper-reserve/artifacts/qj5x12tc_ChatGPT%20Image%2011%20juin%202026%2C%2000_29_08.png",
  transport: "https://customer-assets.emergentagent.com/job_mopper-reserve/artifacts/krvb1wax_ChatGPT%20Image%2011%20juin%202026%2C%2000_45_51.png",
};

// Secondary reassurance image (reused). Falls back to service hero img if missing.
export const REASSURANCE_IMG = "https://customer-assets.emergentagent.com/job_mopper-reserve/artifacts/9hfblbh7_ChatGPT%20Image%2011%20juin%202026%2C%2001_37_19.png";

export const TRUST_BAR = [
  "Équipe professionnelle",
  "Biens protégés",
  "Prix transparent",
  "Véhicules adaptés",
  "Intervention rapide",
  "Service assuré",
  "Suisse romande",
];
export const TRUST_BAR_I18N = {
  fr: ["Équipe professionnelle", "Biens protégés", "Prix transparent", "Véhicules adaptés", "Intervention rapide", "Service assuré", "Suisse romande"],
  de: ["Professionelles Team", "Geschützte Güter", "Transparenter Preis", "Geeignete Fahrzeuge", "Schneller Einsatz", "Versicherter Service", "Westschweiz"],
  en: ["Professional team", "Protected belongings", "Transparent price", "Suitable vehicles", "Fast intervention", "Insured service", "French-speaking Switzerland"],
};

export const HERO_BADGES_I18N = {
  fr: ["Devis gratuit", "Réponse sous 24h", "Sans engagement", "Suisse romande"],
  de: ["Kostenloses Angebot", "Antwort innert 24 h", "Unverbindlich", "Westschweiz"],
  en: ["Free quote", "Reply within 24h", "No commitment", "French-speaking Switzerland"],
};

export const SERVICE_CONTENT = {
  move: {
    badge: "Déménagement",
    promise: "Une équipe formée, des camions adaptés, des biens protégés. Vous emménagez l'esprit léger.",
    heroAlt: "Équipe Mopper en intervention de déménagement",
    includes: [
      { icon: "shield", title: "Protection des biens", text: "Couvertures, films, cartons et sangles fournis pour chaque meuble et objet fragile." },
      { icon: "box", title: "Emballage", text: "Cartons livrés, possibilité d'emballage complet par notre équipe." },
      { icon: "truck", title: "Chargement & transport", text: "Camions 12 à 20m³ avec hayon, sangles d'arrimage, conducteurs expérimentés." },
      { icon: "tool", title: "Démontage / remontage", text: "Lits, dressings IKEA Pax, meubles sur-mesure — démontés à l'arrivée et remontés." },
      { icon: "home", title: "Placement final", text: "Vos meubles installés à l'endroit choisi, prêts à l'usage." },
      { icon: "sparkles", title: "Nettoyage en option", text: "Enchaînez nettoyage fin de bail dans la même prestation, garantie état des lieux." },
    ],
    reassuranceTitle: "Vos biens sont protégés à chaque étape.",
    reassuranceItems: [
      "Couvertures rembourrées pour mobilier",
      "Sangles pro et films de protection",
      "Diables, chariots, monte-meubles si besoin",
      "Protection des sols et des cages d'escalier",
      "Manipulation soignée des objets fragiles",
      "Véhicules adaptés au volume réel",
    ],
    tiers: [
      { name: "Transport essentiel", tagline: "L'option efficace", items: ["Chargement à l'adresse de départ", "Transport sécurisé", "Déchargement à destination"] },
      { name: "Déménagement complet", tagline: "Le plus demandé", highlight: true, items: ["Protection complète des biens", "Démontage des meubles", "Transport sécurisé", "Remontage chez vous", "Placement des meubles"] },
      { name: "Mopper Full", tagline: "Zéro stress, zéro effort", items: ["Emballage des cartons", "Déménagement complet", "Débarras des objets non emportés", "Nettoyage fin de bail", "Remise des clés"] },
    ],
    caseStudy: {
      title: "Déménagement d'un 4.5 pièces à Lausanne",
      bullets: ["22 m³ transportés", "3 déménageurs · 1 camion 20m³", "Démontage + remontage", "Intervention en 1 journée"],
    },
    testimonials: [
      { name: "Sophie M.", city: "Lausanne", rating: 5, text: "Équipe ultra pro, ponctuelle, soigneuse. Le démontage du dressing Pax était impeccable. Je recommande sans hésiter.", type: "Déménagement 3.5 pièces", source: "Google" },
      { name: "Jean-Luc D.", city: "Genève", rating: 5, text: "On a comparé 4 devis. Mopper avait le tarif le plus clair, et l'équipe a tenu tous les délais. Nickel.", type: "Déménagement bureau", source: "Google" },
      { name: "Camille R.", city: "Morges", rating: 5, text: "Le combo déménagement + nettoyage fin de bail nous a vraiment sauvés. État des lieux validé du premier coup.", type: "Déménagement 4.5 pièces" },
    ],
    related: ["clean", "clear", "assembly", "transport"],
  },

  clear: {
    badge: "Débarras",
    promise: "On vide, on trie, on donne, on recycle. Vous récupérez un espace prêt à vivre — sans déplacer un seul carton.",
    heroAlt: "Équipe Mopper en intervention de débarras",
    includes: [
      { icon: "box", title: "Évacuation complète", text: "Caves, greniers, garages, appartements ou maisons entières — on emporte tout." },
      { icon: "sparkles", title: "Tri sur place", text: "On sépare ce qui peut être donné, vendu, recyclé ou jeté — vous validez." },
      { icon: "heart", title: "Don aux associations", text: "Caritas, EMMAÜS et associations locales pour redonner vie à vos objets." },
      { icon: "leaf", title: "Tri responsable", text: "Bois, métal, électronique, textile — chaque matière au bon endroit." },
      { icon: "truck", title: "Déchèterie incluse", text: "Frais et transport déchèterie inclus dans le devis." },
      { icon: "clean", title: "Nettoyage final", text: "Sur demande, un nettoyage complet pour rendre l'espace impeccable." },
    ],
    reassuranceTitle: "Un débarras propre, humain, responsable.",
    reassuranceItems: [
      "Tri systématique avant la déchèterie",
      "Don prioritaire aux associations partenaires",
      "Photos avant/après sur demande",
      "Frais déchèterie compris dans le devis",
      "Discrétion absolue pour les successions",
      "Équipe respectueuse des lieux et des proches",
    ],
    tiers: [
      { name: "Débarras express", tagline: "Le minimum efficace", items: ["Évacuation du volume", "Transport en déchèterie", "Frais inclus"] },
      { name: "Débarras + tri", tagline: "L'équilibre humain", highlight: true, items: ["Évacuation complète", "Tri don / valorisation / déchet", "Mise en lien associations", "Frais déchèterie inclus"] },
      { name: "Mopper Full Clean", tagline: "Tout est prêt pour la suite", items: ["Tri & évacuation complète", "Dons aux associations", "Nettoyage de fond", "État des lieux possible"] },
    ],
    caseStudy: {
      title: "Débarras d'un appartement après succession à Genève",
      bullets: ["80 m² vidés", "12 m³ évacués", "4 m³ donnés à Caritas", "Nettoyage final inclus"],
    },
    testimonials: [
      { name: "Marie-Claude F.", city: "Genève", rating: 5, text: "Mopper a géré la succession de ma mère avec une délicatesse incroyable. Tout a été trié, donné, recyclé. Merci.", type: "Débarras succession", source: "Google" },
      { name: "Thierry V.", city: "Vevey", rating: 5, text: "Devis honnête, équipe rapide. Cave + grenier vidés en une journée, frais déchèterie inclus. Top.", type: "Débarras cave + grenier" },
      { name: "Aline B.", city: "Nyon", rating: 5, text: "On a évité la déchèterie 3 jours d'affilée. Mopper a tout fait en 4h. Du temps gagné, et beaucoup donné.", type: "Débarras appartement", source: "Google" },
    ],
    related: ["clean", "recycle", "declutter", "move"],
  },

  declutter: {
    badge: "Désencombrement",
    promise: "Un accompagnement humain pour alléger votre intérieur — sans tout jeter, sans culpabilité.",
    heroAlt: "Session de désencombrement Mopper",
    includes: [
      { icon: "heart", title: "Approche humaine", text: "On respecte votre rythme, vos émotions, vos souvenirs. Pas de tri imposé." },
      { icon: "layers", title: "Tri par catégories", text: "Garder · donner · vendre · recycler · jeter. Vous validez chaque pile." },
      { icon: "sparkles", title: "Méthode douce", text: "Inspirée des grandes méthodes (KonMari, FlyLady) adaptée à votre vie." },
      { icon: "box", title: "Évacuation immédiate", text: "Ce qui part, part le jour même — on évacue tout à votre place." },
      { icon: "home", title: "Réorganisation", text: "On range ce qui reste de manière fonctionnelle et durable." },
      { icon: "shield", title: "Confidentialité totale", text: "Discrétion absolue. Aucune photo, aucun partage sans votre accord." },
    ],
    reassuranceTitle: "Un intérieur allégé, sans jamais brusquer.",
    reassuranceItems: [
      "Séances de 3 à 4h pour éviter la fatigue",
      "Aucune décision prise sans vous",
      "Conseils pour pérenniser le tri",
      "Don aux associations partenaires",
      "Évacuation immédiate après chaque séance",
      "Accompagnement émotionnel inclus",
    ],
    tiers: [
      { name: "Séance découverte", tagline: "1 zone, 1 demi-journée", items: ["Diagnostic + tri d'une pièce", "Méthode adaptée à vous", "Évacuation incluse"] },
      { name: "Pack progressif", tagline: "Le plus efficace", highlight: true, items: ["3 séances espacées", "Toutes les pièces principales", "Suivi entre séances", "Évacuation à chaque étape"] },
      { name: "Désencombrement complet", tagline: "Maison entière", items: ["Toutes les pièces", "Tri + évacuation + dons", "Réorganisation des espaces", "Conseils anti-rechute"] },
    ],
    caseStudy: {
      title: "Désencombrement d'une maison de 6 pièces à Pully",
      bullets: ["3 séances · 12h au total", "9 m³ donnés ou recyclés", "5 pièces réorganisées", "Aucun objet à conserver oublié"],
    },
    testimonials: [
      { name: "Isabelle K.", city: "Lausanne", rating: 5, text: "Je n'arrivais plus à trier seule. Mopper m'a accompagnée avec une bienveillance incroyable. Je respire enfin chez moi.", type: "Désencombrement appartement", source: "Google" },
      { name: "Patrick L.", city: "Renens", rating: 5, text: "Après le décès de mon père, désencombrer son appartement aurait été insurmontable. Mopper a tout rendu doux.", type: "Désencombrement succession" },
      { name: "Nadia O.", city: "Yverdon", rating: 5, text: "Méthode claire, équipe à l'écoute, zéro pression. J'ai gardé l'essentiel et donné le reste.", type: "Désencombrement maison", source: "Google" },
    ],
    related: ["organize", "clear", "recycle", "clean"],
  },

  organize: {
    badge: "Home Organizing",
    promise: "Des espaces pensés pour la vraie vie. Tout a sa place, vous gagnez du temps tous les jours.",
    heroAlt: "Dressing organisé par Mopper",
    includes: [
      { icon: "home", title: "Audit de vos espaces", text: "On comprend votre quotidien, vos habitudes, vos contraintes." },
      { icon: "layers", title: "Plan d'organisation", text: "Schémas, zones, catégories — un système qui vous ressemble." },
      { icon: "box", title: "Solutions de rangement", text: "Boîtes, séparateurs, paniers, étagères — sur mesure ou prêts à poser." },
      { icon: "tag", title: "Étiquetage", text: "Étiquettes harmonieuses pour que toute la famille sache où trouver et ranger." },
      { icon: "sparkles", title: "Installation complète", text: "On installe, on remplit, on étiquette — vous découvrez le résultat." },
      { icon: "shield", title: "Garantie durabilité", text: "Conseils pour que le rangement tienne dans le temps, même avec des enfants." },
    ],
    reassuranceTitle: "Vos espaces deviennent intuitifs.",
    reassuranceItems: [
      "Dressings clairs et accessibles",
      "Cuisines fonctionnelles (épicerie, frigo, placards)",
      "Bureaux qui boostent la concentration",
      "Chambres d'enfants où ils savent ranger",
      "Buanderies optimisées au mètre carré",
      "Caves et garages remis en logique",
    ],
    tiers: [
      { name: "Zone unique", tagline: "1 espace, 1 résultat", items: ["Audit + plan", "Achats si besoin", "Installation et étiquetage"] },
      { name: "Pack 3 zones", tagline: "Le plus populaire", highlight: true, items: ["Dressing + cuisine + buanderie", "Conseils achats inclus", "Étiquetage complet", "Suivi 1 mois"] },
      { name: "Maison entière", tagline: "L'organisation totale", items: ["Toutes les pièces", "Système familial cohérent", "Étiquetage harmonisé", "Formation des occupants"] },
    ],
    caseStudy: {
      title: "Organisation complète d'une famille à Pully",
      bullets: ["Dressing + cuisine + buanderie + chambres enfants", "2 jours d'intervention", "Système cohérent dans toute la maison", "Gain de temps quotidien : 30 min/jour"],
    },
    testimonials: [
      { name: "Charlotte D.", city: "Lausanne", rating: 5, text: "Mon dressing est devenu un plaisir à utiliser. Tout a sa place, je m'habille en 2 minutes le matin.", type: "Dressing + cuisine", source: "Google" },
      { name: "Olivier B.", city: "Morges", rating: 5, text: "Ma femme et moi étions débordés. Mopper a tout repensé. Les enfants rangent désormais leurs jouets seuls.", type: "Maison familiale" },
      { name: "Sandra V.", city: "Vevey", rating: 5, text: "Approche très pro, conseils sur les boîtes et les étiquettes. Le résultat est magnifique et tient dans le temps.", type: "Cuisine + buanderie", source: "Google" },
    ],
    related: ["declutter", "clean", "move", "assembly"],
  },

  clean: {
    badge: "Nettoyage",
    promise: "Nettoyage fin de bail garanti état des lieux. Vitres, sols, sanitaires, électroménager — rien n'est laissé au hasard.",
    heroAlt: "Nettoyage fin de bail Mopper",
    includes: [
      { icon: "sparkles", title: "Checklist état des lieux", text: "Toutes les zones standards des régies suisses validées." },
      { icon: "home", title: "Vitres int. & ext.", text: "Vitres, baies, cadres et rebords nettoyés sans traces." },
      { icon: "tool", title: "Électroménager", text: "Four, frigo, hotte, plaques, lave-vaisselle — détartrés et désinfectés." },
      { icon: "shield", title: "Sanitaires", text: "Joints, robinetterie, douche, WC — détartrage complet." },
      { icon: "layers", title: "Sols & armoires", text: "Tous les sols lavés, armoires intérieures vidées et nettoyées." },
      { icon: "check", title: "Garantie retour", text: "Si la régie refuse, on revient gratuitement corriger les points." },
    ],
    reassuranceTitle: "Un nettoyage qui passe l'état des lieux.",
    reassuranceItems: [
      "Produits professionnels (CHF / écologiques sur demande)",
      "Checklist régies suisses validée",
      "Vitres parfaites, sans traces",
      "Détartrage complet sanitaires & électroménager",
      "Retour gratuit si la régie refuse",
      "Possibilité de présence à l'état des lieux",
    ],
    tiers: [
      { name: "Nettoyage simple", tagline: "Pour rafraîchir", items: ["Sols, surfaces, sanitaires", "Cuisine de base", "Aspiration complète"] },
      { name: "Nettoyage fin de bail", tagline: "Garantie état des lieux", highlight: true, items: ["Checklist complète", "Vitres int. & ext.", "Électroménager détartré", "Joints, plinthes, armoires", "Retour gratuit en cas de refus"] },
      { name: "Mopper Combo", tagline: "Avec déménagement ou débarras", items: ["Nettoyage fin de bail complet", "Combiné avec déménagement ou débarras", "Un seul interlocuteur", "Une seule date, un seul devis"] },
    ],
    caseStudy: {
      title: "Nettoyage fin de bail d'un 3.5 pièces à Renens",
      bullets: ["75 m² nettoyés", "2 nettoyeurs · 5h", "Vitres + électroménager + sanitaires", "État des lieux validé du premier coup"],
    },
    testimonials: [
      { name: "Léa H.", city: "Lausanne", rating: 5, text: "Régie ultra exigeante validée du premier coup. Vitres parfaites, four comme neuf. Merci !", type: "Nettoyage fin de bail", source: "Google" },
      { name: "Vincent P.", city: "Genève", rating: 5, text: "Combo déménagement + nettoyage. Tout enchaîné en une journée. Aucun stress.", type: "Déménagement + nettoyage" },
      { name: "Maya R.", city: "Nyon", rating: 5, text: "L'équipe est venue à l'état des lieux avec moi. Régie satisfaite, caution récupérée intégralement.", type: "Nettoyage fin de bail", source: "Google" },
    ],
    related: ["move", "clear", "organize", "recycle"],
  },

  recycle: {
    badge: "Recyclage",
    promise: "Tri rigoureux, dons prioritaires, recyclage local. Vos objets ont une seconde vie — ou la bonne fin de vie.",
    heroAlt: "Tri et recyclage Mopper",
    includes: [
      { icon: "leaf", title: "Tri des matériaux", text: "Bois, métal, carton, plastique, textile, électronique — chacun à sa filière." },
      { icon: "heart", title: "Don aux associations", text: "Caritas, EMMAÜS, associations locales — priorité au réemploi." },
      { icon: "box", title: "Revalorisation", text: "Restauration ou revente locale pour donner une seconde vie aux meubles." },
      { icon: "truck", title: "Transport déchèterie", text: "Frais et transport inclus, nous avons les autorisations professionnelles." },
      { icon: "shield", title: "Certificat de tri", text: "Sur demande (entreprises, successions), preuve de bonne gestion." },
      { icon: "sparkles", title: "Démarche locale", text: "Filières suisses romandes, traçabilité maximale." },
    ],
    reassuranceTitle: "Recycler, c'est aussi un acte de respect.",
    reassuranceItems: [
      "Don avant déchèterie — toujours",
      "Filières locales (Vaud, Genève, Fribourg)",
      "Reçu / certificat sur demande",
      "Recyclage électronique conforme",
      "Bois, métal, textile, papier triés à la source",
      "Aucun objet réutilisable jeté inutilement",
    ],
    tiers: [
      { name: "Évacuation simple", tagline: "Tri standard", items: ["Tri par matière", "Évacuation déchèterie", "Frais inclus"] },
      { name: "Tri responsable", tagline: "Le plus complet", highlight: true, items: ["Don aux associations", "Recyclage par filière", "Photos / traçabilité", "Certificat sur demande"] },
      { name: "Pack entreprise", tagline: "Pour B2B & successions", items: ["Évacuation + tri complet", "Certificat officiel", "Facturation TVA", "Confidentialité totale"] },
    ],
    caseStudy: {
      title: "Recyclage d'un bureau à Lausanne",
      bullets: ["18 m³ évacués", "60 % donnés / réemployés", "30 % recyclés (métal, électronique)", "Certificat fourni à l'entreprise"],
    },
    testimonials: [
      { name: "Régine F.", city: "Genève", rating: 5, text: "Bilan de tri détaillé fourni à l'association. Caritas a pu récupérer 4 m³ de meubles encore très bons.", type: "Recyclage succession", source: "Google" },
      { name: "Frédéric T.", city: "Lausanne", rating: 5, text: "On cherchait une équipe sérieuse pour vider notre bureau. Mopper a tout trié, recyclé, et fourni un certificat.", type: "Recyclage entreprise" },
      { name: "Lucie M.", city: "Fribourg", rating: 5, text: "Je voulais éviter la déchèterie. Mopper a trouvé une nouvelle maison à 70% de mes affaires.", type: "Recyclage appartement", source: "Google" },
    ],
    related: ["clear", "declutter", "clean", "transport"],
  },

  assembly: {
    badge: "Montage de meubles",
    promise: "IKEA, Pax, dressings sur-mesure, bureaux pro. On monte, démonte, remonte — vous profitez.",
    heroAlt: "Montage de meubles Mopper",
    includes: [
      { icon: "tool", title: "Montage", text: "Tous types de meubles IKEA, BUT, Conforama, sur-mesure. Notice ou pas, on s'en occupe." },
      { icon: "layers", title: "Démontage", text: "Pour déménagement, vente, ou simple débarras — démontage propre, vis triées." },
      { icon: "box", title: "Remontage à neuf", text: "À l'identique ou amélioré, avec quincaillerie renforcée si besoin." },
      { icon: "truck", title: "Transport du meuble", text: "Sur demande, on va chercher votre meuble (IKEA Aubonne, Vernier) et on l'apporte." },
      { icon: "sparkles", title: "Évacuation ancien meuble", text: "Don, recyclage ou déchèterie — selon votre choix." },
      { icon: "shield", title: "Outils professionnels", text: "Visseuses, niveaux, équerres, fixations murales — équipement complet." },
    ],
    reassuranceTitle: "Du meuble en kit au meuble installé.",
    reassuranceItems: [
      "Outils pro fournis (visseuse, niveau, équerre)",
      "Quincaillerie de remplacement disponible",
      "Fixations murales sécurisées",
      "Démontage soigné (vis triées et étiquetées)",
      "Conseils placement et lumière",
      "Évacuation des cartons incluse",
    ],
    tiers: [
      { name: "Petit meuble", tagline: "Commode, bibliothèque", items: ["Montage simple", "Évacuation des cartons", "Fixation murale incluse"] },
      { name: "Dressing complet", tagline: "Pax, sur-mesure", highlight: true, items: ["Montage du caisson", "Aménagement intérieur", "Fixation murale", "Évacuation cartons"] },
      { name: "Pack pièce entière", tagline: "Chambre, bureau", items: ["Tous les meubles", "Démontage des anciens", "Évacuation incluse", "Conseils ergonomie"] },
    ],
    caseStudy: {
      title: "Montage d'un dressing Pax 4m + bureau à Genève",
      bullets: ["Dressing 4 colonnes + tiroirs + miroirs", "Bureau + caisson + étagères", "Fixation murale anti-bascule", "Évacuation cartons IKEA incluse"],
    },
    testimonials: [
      { name: "Anne-Sophie L.", city: "Genève", rating: 5, text: "Je redoutais le Pax 5m. Mopper a fait ça en 4h, parfait, fixations murales nickel. Bonus : ils ont évacué les cartons.", type: "Dressing Pax", source: "Google" },
      { name: "Mathieu R.", city: "Lausanne", rating: 5, text: "J'avais 3 meubles IKEA en kit qui dormaient depuis 6 mois. Tout est monté, installé, parfait.", type: "3 meubles IKEA" },
      { name: "Carole B.", city: "Vevey", rating: 5, text: "Démontage + transport + remontage de mon bureau à mon nouveau bureau. Une seule équipe, top.", type: "Démontage/remontage", source: "Google" },
    ],
    related: ["move", "transport", "organize", "clear"],
  },

  transport: {
    badge: "Transport de meubles",
    promise: "Un meuble, dix, ou tout un studio. On transporte avec protection pro, en Suisse et au-delà.",
    heroAlt: "Transport de meubles Mopper",
    includes: [
      { icon: "box", title: "Protection complète", text: "Couvertures, films, sangles, cartons sur mesure pour objets fragiles." },
      { icon: "truck", title: "Véhicules adaptés", text: "Du petit utilitaire au camion 20m³ selon votre besoin réel." },
      { icon: "layers", title: "Chargement & déchargement", text: "Équipe expérimentée, montée d'étage incluse jusqu'au placement." },
      { icon: "home", title: "Livraison à l'étage", text: "Étages élevés, sans ascenseur, monte-meubles si nécessaire." },
      { icon: "shield", title: "Assurance professionnelle", text: "Tous les transports couverts par notre assurance pro." },
      { icon: "sparkles", title: "Transport spécialisé", text: "Pianos, œuvres d'art, mobilier de valeur — équipement dédié." },
    ],
    reassuranceTitle: "Du meuble à l'œuvre d'art, transport sans rayure.",
    reassuranceItems: [
      "Couvertures matelassées pour mobilier",
      "Films plastiques et sangles d'arrimage",
      "Diables et chariots professionnels",
      "Monte-meubles disponibles",
      "Conducteurs expérimentés et formés",
      "Assurance professionnelle incluse",
    ],
    tiers: [
      { name: "Transport local", tagline: "Suisse romande", items: ["Chargement + transport", "Déchargement + placement", "Protection standard"] },
      { name: "Transport national", tagline: "Suisse entière", highlight: true, items: ["Toute la Suisse", "Protection renforcée", "Suivi en temps réel", "Assurance incluse"] },
      { name: "Transport international", tagline: "France, UE", items: ["France, Italie, Allemagne, Espagne", "Gestion douane", "Devis spécifique", "Délai 1-2 semaines"] },
    ],
    caseStudy: {
      title: "Transport d'un piano droit Lausanne → Sion",
      bullets: ["Piano droit 220 kg", "4 manutentionnaires + sangles dédiées", "Camion suspension air", "Livraison à l'étage sans ascenseur"],
    },
    testimonials: [
      { name: "Émilie K.", city: "Lausanne", rating: 5, text: "Transport de mon canapé d'angle + table + chaises. Tout est arrivé impeccable, livraison à l'heure dite.", type: "Transport mobilier", source: "Google" },
      { name: "Bernard A.", city: "Sion", rating: 5, text: "Transport d'un piano de famille. Délicatesse incroyable, équipe spécialement formée. Bravo.", type: "Transport piano" },
      { name: "Sophie T.", city: "Nyon", rating: 5, text: "Achat de meubles à Genève, livraison à Nyon. Devis transparent, équipe ponctuelle, placement final inclus.", type: "Transport achat IKEA", source: "Google" },
    ],
    related: ["move", "assembly", "clear", "organize"],
  },
};

export const SERVICE_LABELS = {
  move: "Déménagement",
  clear: "Débarras",
  declutter: "Désencombrement",
  organize: "Home Organizing",
  clean: "Nettoyage",
  recycle: "Recyclage",
  assembly: "Montage de meubles",
  transport: "Transport de meubles",
};


// ============================================================================
// I18N: DE / EN overrides for the most visible parts of ServicePage.jsx
// Testimonials, case studies and tier details remain in FR (brand authenticity).
// ============================================================================
export const SERVICE_PAGE_UI = {
  fr: {
    breadcrumbHome: "Accueil", breadcrumbServices: "Services",
    fastIntervention: "Intervention rapide en Suisse romande",
    kicker: { included: "Ce que Mopper prend en charge", how: "Comment ça marche", solutions: "Une solution pour chaque besoin", field: "Sur le terrain", quality: "Qualité d'intervention", tiers: "Niveaux d'accompagnement", case: "Exemple d'intervention", reviews: "Avis clients", zones: "Zones d'intervention", faq: "Questions fréquentes" },
    includesIntro: (name) => `Chaque intervention ${name.toLowerCase()} inclut l'essentiel — vous validez les options qui vous correspondent.`,
    tiersIntro: "Trois formules adaptées à votre besoin. Le prix dépend de votre situation — demandez votre estimation.",
    tiersBest: "Le plus choisi",
    reviewsVerified: "Avis clients vérifiés",
    zonesIntro: "Vaud, Genève, Fribourg, Neuchâtel, Valais, Jura — cliquez sur votre canton ou vérifiez votre code postal.",
    zonesQuickCheck: "Vérification rapide",
    zonesOutside: "Suisse romande complète. Hors zone, contactez-nous, on étudie chaque demande.",
    discover: "Découvrir",
    serviceLabel: "Service",
  },
  de: {
    breadcrumbHome: "Startseite", breadcrumbServices: "Leistungen",
    fastIntervention: "Schneller Einsatz in der Westschweiz",
    kicker: { included: "Was Mopper übernimmt", how: "So läuft es ab", solutions: "Eine Lösung für jeden Bedarf", field: "Im Einsatz", quality: "Einsatzqualität", tiers: "Begleitungsebenen", case: "Beispiel eines Einsatzes", reviews: "Kundenbewertungen", zones: "Einsatzgebiete", faq: "Häufige Fragen" },
    includesIntro: (name) => `Jeder ${name}-Einsatz umfasst das Wesentliche – Sie wählen die Optionen, die zu Ihnen passen.`,
    tiersIntro: "Drei auf Ihren Bedarf zugeschnittene Pakete. Der Preis hängt von Ihrer Situation ab – fordern Sie Ihren Kostenvoranschlag an.",
    tiersBest: "Am meisten gewählt",
    reviewsVerified: "Verifizierte Kundenbewertungen",
    zonesIntro: "Waadt, Genf, Freiburg, Neuenburg, Wallis, Jura – klicken Sie auf Ihren Kanton oder prüfen Sie Ihre Postleitzahl.",
    zonesQuickCheck: "Schnelle Prüfung",
    zonesOutside: "Gesamte Westschweiz. Ausserhalb der Zone? Kontaktieren Sie uns, wir prüfen jede Anfrage.",
    discover: "Entdecken",
    serviceLabel: "Leistung",
  },
  en: {
    breadcrumbHome: "Home", breadcrumbServices: "Services",
    fastIntervention: "Fast intervention in French-speaking Switzerland",
    kicker: { included: "What Mopper takes care of", how: "How it works", solutions: "A solution for every need", field: "In the field", quality: "Intervention quality", tiers: "Support levels", case: "Sample intervention", reviews: "Client reviews", zones: "Service areas", faq: "Frequent questions" },
    includesIntro: (name) => `Every ${name.toLowerCase()} intervention includes the essentials — you choose the options that suit you.`,
    tiersIntro: "Three packages tailored to your needs. The price depends on your situation — ask for your estimate.",
    tiersBest: "Most chosen",
    reviewsVerified: "Verified client reviews",
    zonesIntro: "Vaud, Geneva, Fribourg, Neuchâtel, Valais, Jura — click your canton or check your postal code.",
    zonesQuickCheck: "Quick check",
    zonesOutside: "All French-speaking Switzerland. Outside the area? Contact us, we review every request.",
    discover: "Discover",
    serviceLabel: "Service",
  },
};

// Per-service translations (badge + promise + reassuranceTitle + heroAlt).
// Other rich content (tiers, includes, testimonials) remains FR.
export const SERVICE_I18N = {
  move: {
    de: { badge: "Umzug", promise: "Geschultes Team, geeignete Lastwagen, geschützte Güter. Sie ziehen mit leichtem Herzen ein.", heroAlt: "Mopper-Team beim Umzugseinsatz", reassuranceTitle: "Ihre Güter sind bei jedem Schritt geschützt." },
    en: { badge: "Moving", promise: "A trained team, suitable trucks, protected belongings. You move in with peace of mind.", heroAlt: "Mopper team handling a move", reassuranceTitle: "Your belongings are protected every step of the way." },
  },
  clear: {
    de: { badge: "Entrümpelung", promise: "Wir leeren, sortieren, spenden und recyceln. Sie erhalten einen bewohnbaren Raum – ohne einen Karton zu heben.", heroAlt: "Mopper-Team bei einer Entrümpelung", reassuranceTitle: "Eine saubere, menschliche, verantwortliche Entrümpelung." },
    en: { badge: "Clear-out", promise: "We empty, sort, donate and recycle. You get a ready-to-live space — without lifting a single box.", heroAlt: "Mopper team clearing a space", reassuranceTitle: "A clean, human, responsible clear-out." },
  },
  declutter: {
    de: { badge: "Aussortieren", promise: "Wir helfen Ihnen, das Wesentliche zu behalten und den Rest verantwortungsvoll loszulassen.", heroAlt: "Aussortieren mit Mopper", reassuranceTitle: "Ein klarer Kopf, ein klarer Raum." },
    en: { badge: "Decluttering", promise: "We help you keep what matters and let go of the rest responsibly.", heroAlt: "Decluttering with Mopper", reassuranceTitle: "A clear mind, a clear space." },
  },
  organize: {
    de: { badge: "Home Organizing", promise: "Wir gestalten Ankleiden, Küchen und Büros neu, damit jeder Gegenstand einen Platz hat.", heroAlt: "Home Organizing mit Mopper", reassuranceTitle: "Ein durchdachter, dauerhafter, schöner Raum." },
    en: { badge: "Home Organizing", promise: "We redesign wardrobes, kitchens and offices so every item has its place.", heroAlt: "Home Organizing by Mopper", reassuranceTitle: "A thoughtful, lasting, beautiful space." },
  },
  clean: {
    de: { badge: "Reinigung", promise: "Endreinigungen, gründliche Reinigungen, regelmässige Pflege – ausgeführt mit Sorgfalt.", heroAlt: "Mopper-Team beim Reinigungseinsatz", reassuranceTitle: "Eine Reinigung, die nichts dem Zufall überlässt." },
    en: { badge: "Cleaning", promise: "End-of-lease cleanings, deep cleanings, regular maintenance — delivered with care.", heroAlt: "Mopper team cleaning", reassuranceTitle: "A cleaning that leaves nothing to chance." },
  },
  recycle: {
    de: { badge: "Recycling", promise: "Wir sortieren, spenden und werten jedes Material auf, das aus Ihrem Raum kommt.", heroAlt: "Verantwortungsvolles Recycling durch Mopper", reassuranceTitle: "Jede Materie an der richtigen Stelle." },
    en: { badge: "Recycling", promise: "We sort, donate and revalorize every material that leaves your space.", heroAlt: "Responsible recycling by Mopper", reassuranceTitle: "Every material in the right place." },
  },
  assembly: {
    de: { badge: "Möbelmontage", promise: "Wir montieren Ihre IKEA-, Ankleide- und Massmöbel sauber, schnell und genau.", heroAlt: "Möbelmontage durch Mopper", reassuranceTitle: "Sorgfältig montiert, schön ausgerichtet." },
    en: { badge: "Furniture assembly", promise: "We assemble your IKEA, wardrobe and custom furniture cleanly, quickly and accurately.", heroAlt: "Furniture assembly by Mopper", reassuranceTitle: "Carefully assembled, perfectly aligned." },
  },
  transport: {
    de: { badge: "Möbeltransport", promise: "Einzelmöbel oder vollständige Lieferungen, in der Schweiz und nach Europa, mit Schutz und Pünktlichkeit.", heroAlt: "Möbeltransport durch Mopper", reassuranceTitle: "Sicher transportiert, pünktlich geliefert." },
    en: { badge: "Furniture transport", promise: "Single items or full deliveries, in Switzerland and across Europe, with protection and punctuality.", heroAlt: "Furniture transport by Mopper", reassuranceTitle: "Safely transported, delivered on time." },
  },
};

// Translated service names map (used in nav, related, breadcrumbs).
export const SERVICE_NAMES_I18N = {
  fr: { move: "Déménagement", clear: "Débarras", declutter: "Désencombrement", organize: "Home Organizing", clean: "Nettoyage", recycle: "Recyclage", assembly: "Montage de meubles", transport: "Transport de meubles" },
  de: { move: "Umzug", clear: "Entrümpelung", declutter: "Aussortieren", organize: "Home Organizing", clean: "Reinigung", recycle: "Recycling", assembly: "Möbelmontage", transport: "Möbeltransport" },
  en: { move: "Moving", clear: "Clear-out", declutter: "Decluttering", organize: "Home Organizing", clean: "Cleaning", recycle: "Recycling", assembly: "Furniture assembly", transport: "Furniture transport" },
};
